// @flow

import * as React from 'react';
import classNames from 'classnames';
import Box from 'sail/Box';
import Group from 'sail/Group';
import Icon from 'sail/Icon';
import {useExpandableState} from 'docs/hooks';
import {Heading} from '../Heading/Heading';

import './Collapsable.scss';

type CollapsableProps = {|
  id?: string,
  className?: string,
  open?: boolean,
  heading: string,
  children: React.Node,
|};

export const Collapsable = ({
  id,
  className,
  open,
  heading,
  children,
}: CollapsableProps) => {
  const [expanded, setExpanded] = useExpandableState(
    !!open,
    id ? `#${id}` : undefined,
  );

  return (
    <Box className={classNames('Collapsable', className)}>
      <Group
        tabIndex={0}
        onClick={() => setExpanded((o) => !o)}
        onKeyPress={(evt) => {
          if (evt.key === 'Enter') {
            setExpanded((o) => !o);
          }
        }}
        direction="horizontal"
        alignItems="center"
        spacing={16}
        className="Collapsable-heading"
      >
        <Icon icon={expanded ? 'chevronDown' : 'chevronRight'} />
        <Heading level={3} id={id} anchored={!!id}>
          {heading}
        </Heading>
      </Group>
      {expanded && (
        <Box padding={{left: 32, top: 8, bottom: 24}}>{children}</Box>
      )}
    </Box>
  );
};
